var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubfolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16185 17.3002C2.47802 17.3002 1.89743 17.0615 1.4201 16.5842C0.942768 16.1069 0.704102 15.5263 0.704102 14.8424V3.15795C0.704102 2.47411 0.942768 1.89353 1.4201 1.4162C1.89743 0.938862 2.47802 0.700195 3.16185 0.700195H8.1521L10.8021 3.3502H18.8464C19.5302 3.3502 20.1108 3.58886 20.5881 4.0662C21.0654 4.54353 21.3041 5.12411 21.3041 5.80795V14.8424C21.3041 15.5263 21.0654 16.1069 20.5881 16.5842C20.1108 17.0615 19.5302 17.3002 18.8464 17.3002H3.16185Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubfolder);
export default __webpack_public_path__ + "static/media/subfolder.a9e049f7c0d0322f420f071e7565c7cf.svg";
export { ForwardRef as ReactComponent };